import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

/**
 * useVerbaPagamentoListaFilter
 */

type State = {
  tipoPesquisa: number;
  valueField: string;
};

type Actions = {
  setTipoPesquisa: SetFunction<number>,
  setValueField: SetFunction<string>,
};

export const useVerbaPagamentoListaFilter = create<State & Actions>((set) => ({
  tipoPesquisa: 1,
  valueField: "",
  setTipoPesquisa: vfn => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setValueField: vfn => SetFunctionImpl(set, 'valueField', vfn),
}));